import api, { toForm, TOKEN_KEY } from './api'
import { storage } from '@/utils/storage'

export const authService = {
  isAuthenticated () {
    return !!storage.get(TOKEN_KEY)
  },

  async login ({ username, password }) {
    const data = await api.post('/api/auth/login', toForm({ username, password }))
    const token = data && (data.token || data.access_token)
    if (!token) throw new Error('LOGIN_FAIL')
    storage.set(TOKEN_KEY, token)
    return data
  },

  // Email verification code used by signup and reset-password.
  // Raw endpoint: { code: 0, data: { otp }, message: "OTP_sent" }.
  // On UAT the OTP comes back in `data.otp`; resolves to it (or '' if absent).
  async sendEmailOtp ({ email, lang }) {
    const res = await api.post('/api/global/sent-otp', toForm({ email, lang }))
    if (res && typeof res === 'object' && 'code' in res && Number(res.code) !== 0) {
      throw new Error(res.message || 'REQUEST_FAILED')
    }
    const otp = res && res.data && res.data.otp
    return otp != null ? String(otp) : ''
  },

  checkEmailOtp ({ email, otp }) {
    return api.get('/api/global/check-otp', { params: { email, otp } })
  },

  // Raw endpoint: array of { id, name, name_en, phone_code, status, ... }
  async countryList () {
    const res = await api.get('/api/global/country_list')
    const rows = Array.isArray(res) ? res : (res && res.data) || []
    return rows.filter(c => Number(c.status) === 1)
  },

  // Params per API doc (username, email, valify_code, password, ref_id),
  // plus `otp`, `password_confirmation`, `country_id` (id from country_list)
  // and `bio` (current UI locale, e.g. "zh" / "en") which the backend also requires.
  signup ({ username, email, code, password, passwordConfirmation, refId, countryId, bio }) {
    return api.post('/api/auth/signup', toForm({
      username,
      email,
      valify_code: '',
      otp: code,
      country_id: countryId,
      bio,
      password,
      password_confirmation: passwordConfirmation,
      ref_id: refId
    }))
  },

  resetPassword ({ email, otp, password }) {
    return api.post('/api/auth/reset-password', toForm({ email, otp, password }))
  },

  async logout () {
    try {
      await api.post('/api/auth/logout')
    } catch (e) {
      // Token may already be invalid — clearing locally is enough.
    } finally {
      storage.remove(TOKEN_KEY)
    }
  }
}
